<template>
  <div class="OphthalmicSystem">
    <div class="page_img">
      <img src="@/assets/img/software_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title font_shadow summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary">眼科/视光HIS系统</div>
      </div>
    </div>
    <div class="page_main ophthalmic_main">
      <img src="@/assets/img/ophthalmic_main.png" alt="">
    </div>
    <div class="page_system flex_column ophthalmic_system" v-for="items in list">
      <div class="sys_title ophthalmic_title flex_column">
        <div class="ophthalmic_summary">{{items.summary}}</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main system_main flex_row" v-for="item in items.item">
        <div class="sys_left system_left flex_row">
          <img :src="item.src" alt="">
        </div>
        <div class="sys_right system_right">
          <div class="title system_title">{{item.title}}</div>
          <div class="info system_info">{{item.info}}</div>
          <div class="tag system_tag" v-for="tag in item.tag"><span></span>{{tag}}</div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'OphthalmicSystem',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
    let list = [
      {
        summary: '眼健康中心的运营端标准化流程',
        item: [{
          src: 'https://ow.visumall.com/public/img/saas.png',
          title: 'SAAS结构定制',
          info: '在流程复杂的行业现状下，打造出自己门店门诊成功的唯一模式',
          tag: ['门店流程的个性化定制创造最好业绩的流程','视光师就是最佳业绩流程的设计者','让顾客真正享有自己的专业验配流程']
        }]
      },
      {
        summary: '眼健康中心的运营端远程诊疗',
        item: [
          {
            src: 'https://ow.visumall.com/public/img/online_consultation.png',
            title: '在线自助问诊',
            info: '标准化问诊最大限度了解顾客的需求给予合理的配镜处方',
            tag: ['门店精准定位目标客户','提高工作效率，避免过度检查','以顾客为中心展开眼健康筛查、问诊']
          },
          {
            src: 'https://ow.visumall.com/public/img/eye_examination.png',
            title: '标准眼部检查',
            info: 'VISUMALL平台应用美国的眼视光标准化模块设计来引导验光师进行规范作业',
            tag: ['不同的门店，不同的员工，相同的技术水平，相同的口碑','让你成为最严谨最值得信赖的店员','顾客放心源于诊疗流程作业的严谨度']
          },
        ]
      },
      {
        summary: '角膜接触镜验配中心',
        item: [
          {
            src: 'https://ow.visumall.com/public/img/AIselection.png',
            title: '标准流程AI选片',
            info: '标准流程操作打造经营者自己的品牌文化，构建门店门诊的软实力',
            tag: ['AI选片不同品牌不同设计都能实现精准定位，完美配适状态','减少换片次数，提高工作效率','让顾客拥有舒适而又快速的试戴体验']
          },
          {
            src: 'https://ow.visumall.com/public/img/CRM.png',
            title: '复查智能CRM',
            info: 'CRM客户管理系统能实现不同职能部门的无缝衔接，协助管理者更好地完成客户管理的任务',
            tag: ['顾客实时跟门店互动，让每一个新顾客都回来复购','每一次的复查都是对你的认可，让你成为顾客的眼健康家庭医生','这里就是贴心']
          },
        ]
      },
      {
        summary: '弱视治疗在线训练中心',
        item: [
          {
            src: 'https://ow.visumall.com/public/img/intelligent_prescription.png',
            title: '智能处方',
            info: 'VISUMALL是全球最成熟和最完善，并取得FDA认证的眼科人工智能技术平台，多种眼病智能诊断',
            tag: ['FDA认证，VISUMALL智能医生坐诊','学习诊断提高专业水平，顾客更加认可','斜弱视问题不再困难，专家就在我身边']
          },
          {
            src: 'https://ow.visumall.com/public/img/intelligent_management.png',
            title: '智能训练管理',
            info: '创造愉悦的智能训练方式，促进视觉健康的发展',
            tag: ['智能视觉训练，实现门店多元化','智能视觉训练更省时省力','视觉训练不再枯燥，在家轻松实现视觉训练']
          },
        ]
      },
      {
        summary: '视功能诊断训练中心',
        item: [
          {
            src: 'https://ow.visumall.com/public/img/diagnostic_prescription.png',
            title: '辅助诊断处方',
            info: 'VISUMALL拥有百万级临床大数据的人工智能数学模型，通过数据分析智能计算并诊断结论',
            tag: ['你将拥有世界顶级的视光师，处方权掌握在手','智能处方，一人多镜，订单更容易成交','人工智能系统处方更可信']
          },
          {
            src: 'https://ow.visumall.com/public/img/training_management.png',
            title: '训练师训练管理',
            info: '打造稳定的团队，培养员工的技能水平，更好的创造价值',
            tag: ['让门店人员更好的提升专业以及管理技能','制定训练方案不用背，不用记，这里就是教科书','视觉训练更规范']
          },
        ]
      },
      {
        summary: '医学验光配镜中心',
        item: [
          {
            src: 'https://ow.visumall.com/public/img/prescription_optimization.png',
            title: '渐进处方优化',
            info: '实现渐进验配无忧和功能型产品的个性化定制成功验配，以提高门店门诊的竞争优势',
            tag: ['把渐进验配占比提高到40%，打造本地最好的渐进验配门店','精准测量，智能分析，个性化佩戴参数定制，渐进零投诉，你就是渐进专家','定制佩戴参数，舒适才是硬道理']
          },
          {
            src: 'https://ow.visumall.com/public/img/scheme_customization.png',
            title: '场景方案定制',
            info: '快速通过智能化场景体验，让顾客了解认可眼视光解决方案以及产品',
            tag: ['销售高端产品，客单价翻一倍，成交率翻一倍，专业认可度100%','场景化讲解和展示复杂的视光专业，让你更自信，更专业','这里才是真正的眼视光，顾客懂才是真的懂.']
          },
        ]
      },
    ];
    this.list = list;
  },
}
</script>

<style scoped lang="scss">
.OphthalmicSystem {
  .content {
    margin-top: 0.4rem;
  }
  .ophthalmic_main {
    margin: 1.5rem 0 1rem;
    img {
      width: 50%;
    }
  }
  .ophthalmic_system {
    margin-bottom: 1.3rem;
    .ophthalmic_title {
      .ophthalmic_summary {
        font-size: 0.3rem;
        font-weight: bold;
      }
    }
    .system_main {
      margin-top: 0.8rem;
      .system_left {
        flex: 1;
        img {
          width: 60%;
        }
      }
      .system_right {
        flex: 1;
        margin-top: 0.2rem;
        .system_title {
          font-weight: bold;
          font-size: 0.25rem;
        }
        .system_info {
          margin-top: 0.22rem;
          font-size: 0.19rem;
        }
        .system_tag {
          position: relative;
          padding-left: 0.25rem;
          width: 60%;
          margin-top: 0.15rem;
          font-size: 0.19rem;
          span {
            display: inline-block;
            position: absolute;
            left: 0;
            top: 0;
            transform: translate(50%,50%);
            width: 0.12rem;
            height: 0.12rem;
            background: #999;
          }
        }
      }
    }
  }

}
</style>
